/* eslint-disable @typescript-eslint/no-explicit-any */

type Rootish = any;

export const selectIsAuthed = (s: Rootish): boolean => {
  const login = s?.login ?? {};
  if (login?.token?.access) return true;
  if (login?.user) return true;
  if (login?.isAuthenticated === true) return true;
  return false;
};

export const hasStoredAccess = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    const t = localStorage.getItem('accessToken');
    return !!t && t !== 'null' && t !== 'undefined';
  } catch {
    return false;
  }
};

export const getAuthHintCookie = (): boolean => {
  if (typeof document === 'undefined') return false;
  return /(?:^|;)\s*auth_hint=1(?:;|$)/.test(document.cookie);
};
export const setAuthHintCookie = (on: boolean) => {
  if (typeof document === 'undefined') return;
  document.cookie = `auth_hint=${on ? '1' : '0'}; Path=/; SameSite=Lax`;
};

export const quickIsAuthed = (state?: Rootish): boolean => {
  if (state && selectIsAuthed(state)) return true;
  if (hasStoredAccess()) return true;
  if (getAuthHintCookie()) return true;
  return false;
};
